import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { WorkflowDefinition, WorkflowDefinitionCreate, WorkflowDefinitionFilter } from '../data/workflowDefinition';

export function createWorkflowDefinitionService(client: AxiosInstance) {
  return createCrudService<WorkflowDefinition, WorkflowDefinitionCreate, WorkflowDefinitionFilter>(
    client,
    '/workflow/WorkflowDefinition',
    'id',
  );
}

export type WorkflowDefinitionService = CrudService<WorkflowDefinition, WorkflowDefinitionCreate, WorkflowDefinitionFilter>;
